<template>
    <nav>
      <Dropdown title="חשבון שלי" :items="services" />
    </nav>
  </template>
  
  <script>
  import Dropdown from './Dropdown';
  
  export default {
    name: 'navbar',
    props:["modalToggle"],
    components: {
      Dropdown
    },
    data () {
      return {
        services: [
          {
            title: 'הגדרות החשבון',
            link: '#',
            
          }
        ]
      }
    }
  }
  </script>
  
  <style>
  
  nav {
    display: flex;
    align-items: center;
    justify-content: center;
    float: right;
  }
  
  nav .menu-item {
    color: #FFF;
    padding: 10px 10px;
    position: relative;
    text-align: center;
    display: flex;
    transition: 0.4s;
    
  }
  
  nav .menu-item.active,
  nav .menu-item:hover {
    background-color: #444;
  }
  
  nav .menu-item a {
    color: inherit;
    text-decoration: none;
    font-size: 12px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/Navbar.vue